import "regenerator-runtime/runtime";

import React, { useEffect, useState } from "react";
import { createRoot } from "react-dom/client";

(function (Drupal) {
  Drupal.behaviors.anchor = {
    attach: function (context, settings) {
      once("anchorList", "#anchor-link-list").forEach(function (element) {
        const rootElement = element.querySelector(
          ".anchor-link-list__container"
        );
        const root = createRoot(rootElement);
        root.render(<App context={element} />);
      });
    },
  };
})(Drupal);

function App(context) {
  const [isLoading, setIsLoading] = useState(true);
  const [linkList, setLinkList] = useState([]);

  const specialLinkTypes = ['H1', 'H2', 'H3', 'H4', 'H5', 'H6'];

  useEffect(() => {
    const getAllAnchorLink = document.querySelectorAll(".anchor-title");

    let titleList = [];
    getAllAnchorLink.forEach((link) => {
      titleList.push(
        {
          linkText: link.innerText,
          linkType: link.parentElement.nodeName
        }
        /* link.innerText */
      );
    });
    setLinkList(titleList);
    setIsLoading(false);
  }, []);

  function convertToSlug(text) {
    return text
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9-]/g, '')
      .replace(/-+/g, '-')
      .replace(/^-|-$/g, '');
  }

  const useAnchorLink = (item) => {
    const getAllAnchorLink = document.querySelectorAll(".anchor-title");

    getAllAnchorLink.forEach((element) => {
      if (element.innerText === item.linkText) {
        const yOffset = -300;
        const y =
          element.getBoundingClientRect().top + window.scrollY + yOffset;

        window.scrollTo({ top: y, behavior: "smooth" });

        window.location.hash = convertToSlug(item.linkText);
      }
    });
  };

  useEffect(() => {
    setTimeout(() => {
      const getAllAnchorLink = document.querySelectorAll(".anchor-title");

      getAllAnchorLink.forEach((item) => {
        if (window.location.hash.substring(1) === convertToSlug(item.innerText)) {
          const yOffset = -300;
          const y =
            item.getBoundingClientRect().top + window.scrollY + yOffset;

          window.scrollTo({ top: y, behavior: "smooth" });
        }
      });
    }, 0);
  }, []);

  return (
    <>
      {!isLoading ? (
        <>
          <div className="anchor-link-list__container--icon">
            <svg
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M6.13333 3C5.81268 3 5.5171 3.12002 5.30878 3.31532C5.10264 3.50858 5 3.75637 5 4L5 7L5 20C5 20.5523 5.44772 21 6 21L17.8667 21C18.1873 21 18.4829 20.88 18.6912 20.6847C18.8974 20.4914 19 20.2436 19 20L19 4C19 3.44771 18.5523 3 18 3L14.1333 3L6.13333 3ZM3.9409 1.85625C4.53273 1.30141 5.3224 1 6.13333 1L14.1333 1L18 1C19.6569 1 21 2.34315 21 4L21 20C21 20.8172 20.6531 21.5869 20.0591 22.1438C19.4673 22.6986 18.6776 23 17.8667 23L6 23C4.34314 23 3 21.6569 3 20L3 7L3 4C3 3.18276 3.34688 2.41314 3.9409 1.85625ZM10 18C10 17.4477 10.4477 17 11 17H13C13.5523 17 14 17.4477 14 18C14 18.5523 13.5523 19 13 19H11C10.4477 19 10 18.5523 10 18ZM11 13C10.4477 13 10 13.4477 10 14C10 14.5523 10.4477 15 11 15H16C16.5523 15 17 14.5523 17 14C17 13.4477 16.5523 13 16 13H11ZM10 10C10 9.44771 10.4477 9 11 9L14 9C14.5523 9 15 9.44771 15 10C15 10.5523 14.5523 11 14 11H11C10.4477 11 10 10.5523 10 10ZM11 5C10.4477 5 10 5.44772 10 6C10 6.55228 10.4477 7 11 7L16 7C16.5523 7 17 6.55228 17 6C17 5.44772 16.5523 5 16 5L11 5ZM9 18C9 18.5523 8.55228 19 8 19C7.44772 19 7 18.5523 7 18C7 17.4477 7.44772 17 8 17C8.55228 17 9 17.4477 9 18ZM8 15C8.55228 15 9 14.5523 9 14C9 13.4477 8.55228 13 8 13C7.44772 13 7 13.4477 7 14C7 14.5523 7.44772 15 8 15ZM9 10C9 10.5523 8.55228 11 8 11C7.44772 11 7 10.5523 7 10C7 9.44771 7.44772 9 8 9C8.55228 9 9 9.44771 9 10ZM8 7C8.55228 7 9 6.55228 9 6C9 5.44772 8.55228 5 8 5C7.44772 5 7 5.44772 7 6C7 6.55228 7.44772 7 8 7Z"
                fill="#423C8D"
              />
            </svg>
          </div>
          <ul className="anchor-link-list__container--text">
            {linkList.map((item, index) => {
              let classList = "anchor-link-item";
              specialLinkTypes.includes(item.linkType) ? classList = classList.concat(" ", item.linkType.toLowerCase()) : null;

              return (
                <li
                  key={index}
                  onClick={(e) => { useAnchorLink(item) }}
                  onKeyUp={(e) => { e.key === 'Enter' ? useAnchorLink(item) : null }}
                  className={classList}
                  tabIndex={0}
                >
                  {item.linkText}
                </li>
              );
            })}
          </ul>
        </>
      ) : (
        <div className="lds-ring">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      )}
    </>
  );
}
